export type PackagesSearchParams = {
  originId: string;
  destinationId: string;
  outboundDate: string;
  inboundDate: string;
  adults: number;
  child_ages: number[];
};

type PackagesRedirectSource =
  'flights-results-banner-mobile' | 'flights-results-banner-desktop' | 'parallel_search';

export const buildPackagesRedirectUrl = (
  params: PackagesSearchParams,
  source: PackagesRedirectSource,
) =>
  `/package-holidays/${params.originId}/${params.destinationId}/${params.outboundDate}/${params.inboundDate}?adultsv2=${params.adults}&childrenv2=${params.child_ages}&source=${source}`;
